const hideIsSfr = [
  'capRtPct',
  'unitPx',
  'tenantsM',
  'detriCond',
  'ffePx',
  'ffeDesc',
]

/**
 * Check if field is hidden in SFR
 * Used in both editableTable.js and tRow.js
 */
export default function isFieldHiddenSfr (field) {
  return hideIsSfr.indexOf(field) !== -1
}



// WEBPACK FOOTER //
// ./modules/utils/isFieldHiddenSfr.js